import { createPortal } from 'react-dom';
import { X, Sparkles, Target, Lightbulb } from 'lucide-react';

const DISMISSED_KEY = 'markerSync_expandCollectionIntroDismissed';

export function hasSeenExpandIntro() {
  return localStorage.getItem(DISMISSED_KEY) === 'true';
}

export function markExpandIntroSeen() {
  localStorage.setItem(DISMISSED_KEY, 'true');
}

export default function ExpandCollectionIntroModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  const handleGotIt = () => {
    markExpandIntroSeen();
    onClose();
  };

  return createPortal(
    <div className="fixed inset-0 z-[60] backdrop-blur-sm bg-black/30 flex items-center justify-center p-4 animate-fadeOnly">
      <div className="bg-white rounded-2xl max-w-sm w-full shadow-2xl border border-slate-100 p-6 animate-slideUp">

        {/* Header */}
        <div className="flex items-start justify-between mb-4">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-violet-400 to-purple-500 flex items-center justify-center shrink-0">
            <Sparkles size={18} className="text-white" />
          </div>
          <button onClick={handleGotIt} className="p-1.5 rounded-lg hover:bg-slate-100 text-slate-400 transition-colors">
            <X size={16} />
          </button>
        </div>

        <h2 className="text-xl font-bold text-slate-900 mb-1">Expand your collection</h2>
        <p className="text-sm text-slate-500 mb-5 leading-relaxed">
          This tool looks at the colors you already own and finds which markers would add the most new hues — covering color ranges you're currently missing, so each new purchase broadens your palette as much as possible.
        </p>

        <div className="space-y-3 mb-6">
          <div className="flex items-start gap-3">
            <div className="w-7 h-7 rounded-lg bg-violet-50 flex items-center justify-center shrink-0 mt-0.5">
              <Target size={14} className="text-violet-500" />
            </div>
            <p className="text-sm text-slate-600 leading-relaxed">
              Pick a brand you partially own. The tool looks at where your color coverage has gaps.
            </p>
          </div>
          <div className="flex items-start gap-3">
            <div className="w-7 h-7 rounded-lg bg-violet-50 flex items-center justify-center shrink-0 mt-0.5">
              <Lightbulb size={14} className="text-violet-500" />
            </div>
            <p className="text-sm text-slate-600 leading-relaxed">
              Choose how many new markers to suggest (1–20). Suggestions are ranked by how much new hue coverage they'd add.
            </p>
          </div>
        </div>

        <p className="text-xs text-slate-400 mb-5 leading-relaxed border-t border-slate-100 pt-4">
          Suggestions are based purely on color distance — they don't account for price, brand availability, or personal preferences. Use them as a starting point, not a shopping list.
        </p>

        <button
          onClick={handleGotIt}
          className="w-full py-2.5 px-4 bg-gradient-to-r from-violet-500 to-purple-500 text-white text-sm font-semibold rounded-xl hover:from-violet-600 hover:to-purple-600 transition-all shadow-sm"
        >
          Got it, let's go
        </button>
      </div>
    </div>,
    document.body
  );
}
